import styled, { css } from 'styled-components'

export type StyledContainerProps = {
  isOpen: boolean
}

export const Container = styled.div<StyledContainerProps>`
  z-index: 333333333333;
  border-radius: 10px;
  background: #f9f9fb;
  box-shadow: 0px 4px 20px 0px rgba(98, 98, 147, 0.22);
  width: 370px;
  padding: 30px;
  flex-direction: column;
  row-gap: 20px;

  ${({ isOpen }) =>
    css`
      display: ${isOpen ? 'flex' : 'none'};
    `}
`

export const Title = styled.h5`
  margin: 0;
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
`

export const Subtitle = styled.p`
  margin-top: -10px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  column-gap: 20px;
`
